import { FactType } from '../../facts/interfaces/fact';
import { CountriesMap } from '../dictionaries/countries';
import { LanguagesDictionary } from '../dictionaries/languages';
import { BarGroupConfig, BarGroupRender, BarGroupSelectorType, BarGroupType, ItemTitleCasing } from '../model/model-bar-chart';
import { SignalsPanel, SignalsPanelType, SignalsType, SignalsVisualization, SignalsVizPanel } from '../model/types';

export const MAX_NUM_RANKING = 5;
export const INCLUDED_TYPE_TIMELINE = [SignalsType.DOCUMENT_TYPE, SignalsType.COUNTRY];

// All filter panels
export const SignalsProperties: Array<SignalsPanel> = [
  {
    type: SignalsType.PUBLISHED_DATE,
    panelType: SignalsPanelType.SPECIAL_PROPERTY,
    showAsFilter: true,
    selected: true,
    dictionary: null,
    titleCase: ItemTitleCasing.KeepOriginalCase,
    order: 0
  },
  {
    type: SignalsType.DOCUMENT_TYPE,
    dictionary: null,
    selectionType: BarGroupSelectorType.CUSTOM,
    selected: true,
    showAsFilter: true,
    panelType: SignalsPanelType.CHECKBOXES,
    titleCase: ItemTitleCasing.SmartTitleCase,
    order: 1
  },
  {
    type: SignalsType.COUNTRY,
    dictionary: CountriesMap,
    selectionType: BarGroupSelectorType.NORMAL,
    selected: true,
    showAsFilter: true,
    panelType: SignalsPanelType.PROPERTY,
    titleCase: ItemTitleCasing.SmartTitleCase,
    icon: 'icon2-x16-world',
    order: 2
  },
  {
    label: SignalsType.CATEGORY,
    type: SignalsType.CATEGORY,
    dictionary: null,
    selected: true,
    showAsFilter: true,
    selectionType: BarGroupSelectorType.HIERARCHICAL,
    panelType: SignalsPanelType.PROPERTY,
    titleCase: ItemTitleCasing.SmartTitleCase,
    icon: 'icon2-x16-view-grid',
    order: 3
  },
  {
    label: 'topic',
    type: SignalsType.TOPICS,
    oldType: SignalsType.TOPICS_OLD,
    aggregateType: SignalsType.TOPICS_AGGREGATE,
    emptyAggregateType: SignalsType.EMPTY_AGGREGATE,
    dictionary: null,
    selected: true,
    selectionType: BarGroupSelectorType.CUSTOM,
    showAsFilter: true,
    panelType: SignalsPanelType.PROPERTY,
    titleCase: ItemTitleCasing.SmartTitleCase,
    icon: 'icon2-x16-tag',
    order: 4,
    factEntity: true,
    factType: FactType.Topic
  },
  {
    label: SignalsType.SOURCE,
    type: SignalsType.SOURCE,
    dictionary: null,
    selected: false,
    selectionType: BarGroupSelectorType.CUSTOM,
    showAsFilter: true,
    panelType: SignalsPanelType.PROPERTY,
    titleCase: ItemTitleCasing.KeepOriginalCase,
    icon: 'icon2-x16-link',
    order: 5
  },
  {
    type: SignalsType.LANGUAGE,
    dictionary: LanguagesDictionary,
    selected: false,
    selectionType: BarGroupSelectorType.NORMAL,
    showAsFilter: true,
    panelType: SignalsPanelType.PROPERTY,
    titleCase: ItemTitleCasing.ForceTitleCase,
    icon: 'icon2-x16-language',
    order: 6
  },
  {
    type: SignalsType.PEOPLE,
    oldType: SignalsType.PEOPLE_OLD,
    aggregateType: SignalsType.PEOPLE_AGGREGATE,
    emptyAggregateType: SignalsType.EMPTY_AGGREGATE,
    dictionary: null,
    selected: false,
    selectionType: BarGroupSelectorType.SUGGESTION,
    showAsFilter: true,
    panelType: SignalsPanelType.PROPERTY,
    titleCase: ItemTitleCasing.ForceTitleCase,
    icon: 'icon2-x16-user-m',
    order: 7,
    factEntity: true,
    factType: FactType.Person
  },
  {
    label: SignalsType.ORGANIZATIONS,
    type: SignalsType.ORGANIZATIONS,
    oldType: SignalsType.ORGANIZATIONS_OLD,
    aggregateType: SignalsType.ORGANIZATIONS_AGGREGATE,
    emptyAggregateType: SignalsType.EMPTY_AGGREGATE,
    dictionary: null,
    selected: false,
    selectionType: BarGroupSelectorType.SUGGESTION,
    showAsFilter: true,
    panelType: SignalsPanelType.PROPERTY,
    titleCase: ItemTitleCasing.SmartTitleCase,
    featureFlag: 'insights.app.facts-organizations',
    icon: 'icon2-x16-organization',
    order: 8,
    factEntity: true,
    factType: FactType.Organization
  },
  {
    label: SignalsType.PLACES,
    type: SignalsType.PLACES,
    oldType: SignalsType.PLACES_OLD,
    aggregateType: SignalsType.PLACES_AGGREGATE,
    emptyAggregateType: SignalsType.EMPTY_AGGREGATE,
    dictionary: null,
    selected: false,
    selectionType: BarGroupSelectorType.SUGGESTION,
    showAsFilter: true,
    panelType: SignalsPanelType.PROPERTY,
    titleCase: ItemTitleCasing.SmartTitleCase,
    icon: 'icon2-x16-place',
    order: 9,
    factEntity: true,
    factType: FactType.Place
  },
  {
    type: SignalsType.SEARCHFIELD,
    dictionary: null,
    selected: false,
    showAsFilter: true,
    panelType: SignalsPanelType.PROPERTY,
    disabledTooltip: 'insights-ng.manageFilters.disabledTooltips.searchField',
    titleCase: ItemTitleCasing.KeepOriginalCase,
    icon: 'icon2-x16-bookmark',
    order: 10
  },
  {
    type: SignalsType.TOPICS,
    dictionary: null,
    selected: true,
    panelType: SignalsPanelType.CUSTOM,
    titleCase: ItemTitleCasing.SmartTitleCase,
    order: 11
  },
  {
    label: SignalsType.COMPANIES,
    type: SignalsType.COMPANIES,
    dictionary: null,
    selected: true,
    showAsFilter: true,
    selectionType: BarGroupSelectorType.CUSTOM,
    panelType: SignalsPanelType.PROPERTY,
    featureFlag: 'insights.app.facts-companies',
    titleCase: ItemTitleCasing.SmartTitleCase,
    icon: 'icon2-x16-organization',
    order: 12,
    factEntity: true,
    factType: FactType.Corporation
  },
  {
    label: SignalsType.STARTUPS,
    type: SignalsType.STARTUPS,
    dictionary: null,
    selected: false,
    showAsFilter: true,
    selectionType: BarGroupSelectorType.CUSTOM,
    panelType: SignalsPanelType.PROPERTY,
    featureFlag: 'insights.app.facts-startups',
    titleCase: ItemTitleCasing.SmartTitleCase,
    icon: 'icon2-x16-organization',
    order: 13,
    factEntity: true,
    factType: FactType.StartUp
  },
  {
    label: SignalsType.TECHNOLOGIES,
    type: SignalsType.TECHNOLOGIES,
    dictionary: null,
    selected: true,
    showAsFilter: true,
    selectionType: BarGroupSelectorType.CUSTOM,
    panelType: SignalsPanelType.PROPERTY,
    featureFlag: 'insights.app.facts-technologies',
    titleCase: ItemTitleCasing.SmartTitleCase,
    icon: 'icon2-x16-technology',
    order: 14,
    factEntity: true,
    factType: FactType.Technology
  },
  {
    label: SignalsType.PRODUCTS,
    type: SignalsType.PRODUCTS,
    dictionary: null,
    selected: false,
    showAsFilter: true,
    selectionType: BarGroupSelectorType.CUSTOM,
    panelType: SignalsPanelType.PROPERTY,
    featureFlag: 'insights.app.facts-products',
    titleCase: ItemTitleCasing.SmartTitleCase,
    icon: 'icon2-x16-product',
    order: 15,
    factEntity: true,
    factType: FactType.Product
  },
  {
    label: SignalsType.INDUSTRIES,
    type: SignalsType.INDUSTRIES,
    dictionary: null,
    selected: true,
    showAsFilter: true,
    selectionType: BarGroupSelectorType.CUSTOM,
    panelType: SignalsPanelType.PROPERTY,
    featureFlag: 'insights.app.facts-industries',
    titleCase: ItemTitleCasing.ForceTitleCase,
    icon: 'icon2-x16-industry',
    order: 16,
    factEntity: true,
    factType: FactType.Industry
  }
];

// All visualization panels
export const InsightsVisualizationProperties: Array<SignalsVizPanel> = [
  {
    label: SignalsVisualization.TIMELINE,
    type: SignalsVisualization.TIMELINE,
    selected: true,
    order: 0
  },
  {
    label: SignalsVisualization.WORLDMAP,
    type: SignalsVisualization.WORLDMAP,
    selected: true,
    order: 1
  },
  {
    label: SignalsVisualization.CIRCLE_PACKING,
    type: SignalsVisualization.CIRCLE_PACKING,
    selected: true,
    order: 2
  },
  {
    label: SignalsVisualization.TOPIC_CLUSTERS,
    type: SignalsVisualization.TOPIC_CLUSTERS,
    selected: true,
    order: 3,
    featureFlag: 'insights.app.cluster-visualisation-topics'
  }
];

export const TOAST_CIRCULAR_DEPENDENCY_ID = 'toast_circular_dependency';
export const CIRCULAR_DEPENDENCY_ERROR_MSG = 'Circular dependency';

export const DEFAULT_GROUP_CONFIG: Array<BarGroupConfig> = [
  {
    label: BarGroupType.SELECT_DROPDOWN,
    actions: {
      deselect: true
    },
    render: BarGroupRender.SELECTOR
  },
  {
    label: BarGroupType.TOP,
    actions: {
      deselect: true
    },
    render: BarGroupRender.BAR
  }
];

export const CATEGORY_PROPERTY = 'hierarchicalLabel';

export enum RemoteStorageKeys {
  SELECTED_SEARCH_FIELD_URI = 'insights.selectedSearchFieldUri',
  GLOBAL_FILTER_QS = 'insights.globalFilterQueryString',
  SELECTED_FILTER_PANELS = 'insights.selectedFilterPanels',
  SELECTED_VISUALIZATION_PANELS = 'insights.selectedVisualizationPanels'
}

export enum Errors {
  InternalServerError = 500,
  Timeout = 504
}

export enum ElementFilterIds {
  SIGNAL_RELATED_ELEMENT = 'signal-related-element'
}

export const TITLE_CASE_DEFAULT_LANGUAGE = 'en';
export const SMART_TITLE_CASE_ARG = 'skip';

// Strong signals feature flag.
export const STRONG_SIGNALS_FEATURE_FLAG: string = 'signals.app.strong-signals';
